import CoursePage from './CoursePage';

export default CoursePage;
